<!--
 * @Descripttion:
 * @version:
 * @Author: shenlin
 * @Date: 2022-04-27 17:00:49
 * @LastEditors: shenlin
 * @LastEditTime: 2022-07-18 17:27:23
-->
<template>
  <div class="container">
    <nav-bar :active.sync="active"></nav-bar>
    <components :is="comps[active]" @getReply="getReply"></components>
  </div>
</template>
<script>
import navBar from './components/navBar' // 导航栏
// import center from './components/center'
import center from './components/adminClock'
import order from './components/order'
import intermediary from './components/intermediary'
import { getToken } from '@utils'
export default {
  components: { navBar, center, order, intermediary },
  data() {
    return {
      active: '',
      comps: ['center', 'order', 'intermediary']
    }
  },
  created() {
    if (getToken()) {
      if (this.$route.query.name === '1') {
        this.active = 2
      } else if (this.$route.query.active === '1') {
        this.active = 1
      } else {
        this.active = 0
      }
    }
  },
  methods: {
    getReply(val) {
      console.log(val)
      this.active = val
    }
  }
}
</script>
